import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { listUserLogins } from "../../../../models/users";
import { Select, Spin } from "antd";
import axios from "axios";
import { ServiceUrl } from "../../../../utils/serviceUrl";

const AddNocType = (props) => {
    const [loader, setLoader] = useState(false);
    const [validated, setValidated] = useState(false);
    const [selUserNames, setSelUserNames] = useState("");
    const [selUserNamesData, setSelUserNamesData] = useState("");
    const [examStaff, setExamStaff] = useState([]);
    const [selEditorContent, setEditorContent] = useState("");
    const handleFormSubmit = (e) => {
        e.preventDefault();
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.stopPropagation();
            setValidated(true);
            return;
        }
        setLoader(true);
        axios
            .post(ServiceUrl.CERTIFICATE.NOCS.ADD_NOC_TYPE, new FormData(form))
            .then((res) => {
                if (res["data"].status == "1") {
                    document.getElementById("frm_saveCourse").reset();
                    if (props.onSuccess) props.onSuccess();

                    toast.success(res["data"].message || "Error");
                    setEditorContent("");

                } else {
                    toast.error(res["data"].message || "Error");
                }
                setLoader(false);
            });
    };
    const loadStaffs = () => {
        var form = new FormData();
        form.append("academic_department", "NOT_NULL");

        axios.post(ServiceUrl.HR.LIST_EMPLOYEES, form).then((res) => {
            if (res["data"].status == "1") {
                setExamStaff(res["data"].data);
            } else {
                toast.error(res["data"].message || "Error");
            }
        });
    };
    useEffect(() => {
        loadStaffs();
    }, []);

    return (
        <>
            <Spin spinning={loader}>
                <Form
                    method="post"
                    noValidate
                    validated={validated}
                    id="frm_saveCourse"
                    onSubmit={handleFormSubmit}
                >
                    <Row className="mt-3">
                        <Col md={12}>
                            <Row>
                                <Col md={4}>
                                    <label className="fs-sm">
                                        Type Name:<span className="text-danger">*</span>
                                    </label>
                                </Col>
                                <Col md={7}>
                                    <Form.Control
                                        type="text"
                                        size="sm"
                                        className="fw-bold"
                                        name="noc_type_name"
                                        required
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}>
                                    <input
                                        type="hidden"
                                        name="approving_employee_ids"
                                        value={selUserNames ? selUserNames.join(",") : ""}
                                    />
                                    <label className="fs-sm">Allowed Employees to approve:
                                        <span className="text-danger">*</span></label>
                                </Col>
                                <Col md={7}>
                                    <Select
                                        showSearch
                                        placeholder="Select Staff Name"
                                        name="approving_employee_ids"
                                        optionFilterProp="children"
                                        mode="multiple"
                                        style={{
                                            width: "100%",
                                        }}
                                        onChange={(list) => setSelUserNames(list)}
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        <Select.Option value="">Select Employee  Name</Select.Option>
                                        {examStaff.map((item) => {
                                            return (
                                                <Select.Option value={item.id}>
                                                    {" "}
                                                    {item.emp_name}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={4}>
                                    <label className="fs-sm">Can Superior approve NOCs:<span className="text-danger">*</span></label>
                                </Col>
                                <Col md={7}>
                                    <div className="d-flex justify-content-md-start justify-content-between gap-1">
                                        <Form.Check
                                            type="radio"
                                            id="superiorApprovalCheckboxYes"
                                            label="Yes"
                                            className="fw-bold"
                                            name="is_superior_approve"
                                            value="1"
                                            required

                                        />
                                        <Form.Check
                                            type="radio"
                                            id="superiorApprovalCheckboxNo"
                                            label="No"
                                            className="fw-bold"
                                            name="is_superior_approve"
                                            value="0"
                                            required

                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col md={10}>
                                    <div className="text-end">
                                        <Button
                                            type="reset"
                                            size="sm"
                                            variant="danger"
                                            className="me-2"
                                        >
                                            <i className="fa fa-xmark me-2 pe-2 border-right"></i>
                                            Reset
                                        </Button>
                                        <Button type="submit" size="sm" variant="secondary">
                                            <i className="fa fa-check me-2 pe-2 border-right"></i>Save
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form >
            </Spin >
        </>
    );
};

export default withRouter(AddNocType);
